import React from "react";
import { connect } from 'react-redux';

// Function to add link to phone number with '-' seperated 
// will change this code to common.tools.linkphonenumber once api will correct itself
const linkPhoneNumber = (stringWithPhoneNumber) => {
    const regex = /.*(\d{3}\-[A-Z]{3}\-[A-Z]{4}[ ][(]\d{3}\-\d{3}\-\d{4}[)]).*/;
    const matchedPhoneNumber = stringWithPhoneNumber.match(regex) && stringWithPhoneNumber.match(regex)[1];
    const linkedPhoneNumber = `<a href="tel:${matchedPhoneNumber}">${matchedPhoneNumber}</a>`;
    if (matchedPhoneNumber)
        stringWithPhoneNumber = stringWithPhoneNumber.replace(matchedPhoneNumber, linkedPhoneNumber);
    return stringWithPhoneNumber;
};

const linkURL = (stringWithURL) => {
    const regex = /[[](https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/;
    const matchedURL = (stringWithURL.match(regex) && stringWithURL.match(regex)[0]) || "";
    const linkedURL = `<a target="_blank" href="${matchedURL.replace("[", "").replace("]", "")}">${matchedURL}</a>`;
    if (linkedURL)
        stringWithURL = stringWithURL.replace(matchedURL, linkedURL);
    return stringWithURL;
}

const ActionPlanTile = props => {
    const { report, currentYear } = props;
    let discussion = [];
    let hasDiscussion = false;
    // Get Current year data to show current year score 
    let currentYearReport = report && report.length > 0 && report.filter(item => item.year === currentYear)[0];
    if (currentYearReport && currentYearReport.discussionPoints && currentYearReport.discussionPoints.length > 0) {
        discussion = currentYearReport.discussionPoints.map((discussion, i) => {
            let html = linkPhoneNumber(discussion);
            html = linkURL(html);
            hasDiscussion = true;
            return (
                <li key={"discussionPoints_" + i} dangerouslySetInnerHTML={{
                    __html: html
                }}></li>
            );
        });
    }
    try {
        return <div className="card actionPlan-tile">
            <div className="card-header">
               
                <div className="row">
                    <div className="col-12">
                        <div className="card-heading d-flex">
                            <span className="svg-discussion"></span>
                            <div className="actionPlan-heading">ACTION PLAN</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-12">
                        {hasDiscussion === true ?
                            <ul className="angle-bullets">
                                {discussion}
                            </ul>
                            :
                            <p>Find a doctor or specialist if you would like to discuss your wellness report.</p>
                        }
                    </div>
                </div>
            </div>
        </div>;
    } catch (ex) {
        console.error(ex);
    }
}

function mapStateToProps(state) {
    return {
        report: state.thrive.report
    };
}

export default connect(mapStateToProps, null)(ActionPlanTile);